import styles from './AboutCard.module.css';

const themeClasses = {
    light: styles.aboutCardLight,
    blue: styles.aboutCardBlue,
    dark: styles.aboutCardDark,
};

const AboutCard = ({ id, title, description, theme, imageSrc }) => {

    return (
        <div className={`${styles.aboutCard} ${themeClasses[theme] || ''}`}>
            <div className={styles.aboutCardContent}>

                {/* Text section */}
                <div className={styles.aboutTextSection}>
                    <div className={styles.textSectionTitle}>
                        {title}
                    </div>

                    <div className={styles.textSectionDescription}>
                        {description}
                    </div>
                </div>

                {/* Image section */}
                {id === 'plan' && (
                    <div
                        className={styles.aboutImageSection}
                        style={{ background: "#0d0d0d" }}
                    >
                        <img src={imageSrc[0]} alt="Plan itinerary picture" className={styles.planItinerary1} loading="lazy" decoding="async" />
                        <img src={imageSrc[1]} alt="Plan itinerary picture" className={styles.planItinerary2} loading="lazy" decoding="async" />
                    </div>
                )}

                {/* Collab section */}
                {id === 'collab' && (
                    <div
                        className={styles.aboutImageSection}
                        style={{ background: "#c2dcef" }}
                    >
                        <img src={imageSrc[0]} alt="Easy collaboration picture" className={styles.easyCollaboration1} loading="lazy" decoding="async" />
                        <img src={imageSrc[1]} alt="Easy collaboration picture" className={styles.easyCollaboration2} loading="lazy" decoding="async" />
                    </div>
                )}

                {/* Spending section */}
                {id === 'spending' && (
                    <div
                        className={styles.aboutImageSection}
                        style={{ background: "#f2e3a8" }}
                    >
                        <img src={imageSrc[0]} alt="Manage spending picture" className={styles.manageSpending1} loading="lazy" decoding="async" />
                        <img src={imageSrc[1]} alt="Manage spending picture" className={styles.manageSpending2} loading="lazy" decoding="async" />
                        <img src={imageSrc[2]} alt="Manage spending picture" className={styles.manageSpending3} loading="lazy" decoding="async" />
                    </div>
                )}
            </div>
        </div>
    );
};

export default AboutCard;
